import {
  RETRIEVE_STORAGE_CATEGORIES,
  UPDATE_STORAGE_CATEGORY,
} from "../actions/types";

const initialState = { storageCategories: [] };

const storageCategoryReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case RETRIEVE_STORAGE_CATEGORIES:
      return {
        storageCategories: payload.rows,
        count: payload.count,
      };

    case UPDATE_STORAGE_CATEGORY:
      return payload;
    default:
      return state;
  }
};

export default storageCategoryReducer;
